import React, { useMemo } from "react";
import { createRoot } from "react-dom/client";

import { ThemeProvider } from "@emotion/react";
import {
  DiscountMessageBoxWidgetTheme,
  IgMessageBoxBaseProps,
  WidgetPrefixes,
} from "@intelligems/ig-types";

import { DiscountMessageBoxContext } from "../context";
import { FullIgTheme, IgWidgetTheme } from "../theme";

import { DiscountMessageBox } from "./DiscountMessageBox";

export const IgMessageBoxBase = ({
  idForHiding,
  prefix,
  config,
  updateIgVars,
  isMobile,
  getWidgetConfig,
  isFe,
  isHidden,
}: IgMessageBoxBaseProps) => {
  const prefixes: WidgetPrefixes | undefined = useMemo(() => {
    if (prefix) {
      return {
        "ig-mb": prefix,
      };
    }
    return undefined;
  }, [prefix]);

  const deviceConfig = useMemo(() => {
    if (isMobile && config.mobile) {
      return config.mobile;
    } else {
      return config.desktop || {};
    }
  }, [isMobile]);

  const theme = useMemo(() => {
    if (isMobile) {
      return IgWidgetTheme(
        config.mobile?.variant ||
          config.desktop?.variant ||
          "messageBoxPopupWidget1",
        true,
        prefixes
      ) as DiscountMessageBoxWidgetTheme;
    }
    return IgWidgetTheme(
      config.desktop?.variant || "messageBoxPopupWidget1",
      false,
      prefixes
    ) as DiscountMessageBoxWidgetTheme;
  }, [isMobile, config.desktop?.variant, config.mobile?.variant]);

  const MessageBox = useMemo(() => {
    if (deviceConfig.variant === "messageBoxPopupWidget1") {
      return DiscountMessageBox;
    } else {
      return DiscountMessageBox;
    }
  }, [deviceConfig.variant]);

  return (
    <ThemeProvider theme={FullIgTheme(isMobile, prefixes)}>
      <DiscountMessageBoxContext.Provider
        value={{
          config,
          idForHiding,
          prefixes,
          isFe,
          theme,
          getWidgetConfig,
          isMobile,
          updateIgVars,
          isHidden,
        }}
      >
        <MessageBox dontRenderCloseButton={isFe} />
      </DiscountMessageBoxContext.Provider>
    </ThemeProvider>
  );
};

export { createRoot };
